(function () {
    baguetteBox.run('.gallery');
    baguetteBox.run('.blocks-gallery-grid');
    baguetteBox.run('.article-page__content p');
})(baguetteBox)